import { PdfViewerModule } from "ng2-pdf-viewer";
import { SafePipe } from "./safe-pipe";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { BootstrapModule } from "libs/core/src/lib/modules/bootstrap.module";
import { TitleBarComponent } from "./title-bar/title-bar.component";
import { SearchBarComponent } from "./search-bar/search-bar.component";
import { FilterBarComponent } from "./filter-bar/filter-bar.component";
import { ImageViewerComponent } from "./image-viewer/image-viewer.component";
import { AlertDialogComponent } from "./alert-dialog/alert-dialog.component";
import { CutsheetDetailsComponent } from "./cutsheet-details/cutsheet-details.component";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgbAccordion, NgbAccordionConfig, NgbAccordionModule, NgbActiveModal, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxGalleryModule } from "@kolkov/ngx-gallery";
import { ApprovalRequestComponent } from "./approval-request/approval-request.component";
import { ReportDialogComponent } from "./report-dialog/report-dialog.component";
import { RxrReportComponent } from "./rxr-report/rxr-report.component";
import { NotesMeetingReportComponent } from "./notes-meeting-report/notes-meeting-report.component";
import { TreeviewModule } from "ngx-treeview";
import { FolderTreeviewComponent } from "./folder-treeview/folder-treeview.component";
import { FolderExplorerComponent } from "./folder-explorer/folder-explorer.component";
import { DynamicDropdownComponent } from "./dynamic-dropdown/dynamic-dropdown.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { StaticTableComponent } from "./static-table/static-table.component";
import { AddJsnRoomComponent } from "./add-jsn-room/add-jsn-room.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { AddAccountDialogComponent } from './add-account-dialog/add-account-dialog.component';
import { PrintCutsheetComponent } from "./print-cutsheet/print-cutsheet.component";
import { CloseCutsheetDialogComponent } from './close-cutsheet-dialog/close-cutsheet-dialog.component';
import { CutsheetImagesComponent } from './cutsheet-images/cutsheet-images.component';
import { PendingApprovalTooltipDirective } from "../directives/pending-approval-tooltip.directive";
import { ProgressModalComponent } from './progress-modal/progress-modal.component';
import { CutsheetGalleryComponent } from './cutsheet-gallery/cutsheet-gallery.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    TitleBarComponent,
    SearchBarComponent,
    FilterBarComponent,
    ImageViewerComponent,
    AlertDialogComponent,
    CutsheetDetailsComponent,
    ApprovalRequestComponent,
    ReportDialogComponent,
    RxrReportComponent,
    NotesMeetingReportComponent,
    SafePipe,
    FolderTreeviewComponent,
    FolderExplorerComponent,
    DynamicDropdownComponent,
    UserProfileComponent,
    StaticTableComponent,
    AddJsnRoomComponent,
    AddAccountDialogComponent,
    PrintCutsheetComponent,
    CloseCutsheetDialogComponent,
    CutsheetImagesComponent,
    PendingApprovalTooltipDirective,
    ProgressModalComponent,
    CutsheetGalleryComponent
  ],
  imports: [
    CommonModule,
    NgxGalleryModule,
    BootstrapModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    PdfViewerModule,
    TreeviewModule.forRoot(),
    NgSelectModule,
    NgbAccordionModule,
    NgbTooltipModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    TitleBarComponent,
    SearchBarComponent,
    FilterBarComponent,
    ImageViewerComponent,
    AlertDialogComponent,
    CutsheetDetailsComponent,
    ApprovalRequestComponent,
    ReportDialogComponent,
    RxrReportComponent,
    NotesMeetingReportComponent,
    PdfViewerModule,
    SafePipe,
    TreeviewModule,
    FolderTreeviewComponent,
    FolderExplorerComponent,
    DynamicDropdownComponent,
    UserProfileComponent,
    StaticTableComponent,
    PendingApprovalTooltipDirective
  ],
  providers: [NgbActiveModal],
})
export class ComponentsModule {}
